import React from 'react';
import Translator from 'components/base-components/Translator';
import { DeficiencyItemModel } from 'models/order';

export default function descriptionTemplate(data: DeficiencyItemModel) {
  return <Translator from={data?.orderProduct} field="name" />;
}
